// @ts-check
import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import useLeftHandLayout from 'components/LeftHandLayout/context';
import { useMasquerade } from 'modules/oidc/useAuthenticated';
import { useNavTopInnerX, useNavTopOuterY, useNavTopSize } from '../navSetter';
import BasketAdmin from './contents/BasketAdmin';
import LogoutOnly from './contents/LogoutOnly';
import OrderConfirmation from './contents/OrderConfirmation';
import Standard from './contents/Standard';
import Suspended from './contents/Suspended';
import Terminated from './contents/Terminated';
import Unauthed from './contents/Unauthed';
import VerificationRequired from './contents/VerificationRequired';
import MasqueradeNote from '../common/MasqueradeNote';

const LargeNavContent = () => {
	const { roles, path } = useLeftHandLayout();

	if (!roles.loggedIn) {
		return <Unauthed />;
	}

	if (roles.loggedIn && roles.basketAdmin) {
		return <BasketAdmin />;
	}

	if (roles.loggedIn && !roles.accountLogin) {
		return <LogoutOnly />;
	}

	if (roles.terminated) {
		return <Terminated />;
	}

	if (roles.suspended) {
		return <Suspended />;
	}

	if (roles.verificationRequired) {
		return <VerificationRequired />;
	}

	if (path === '/shop/complete') {
		return <OrderConfirmation />;
	}

	return <Standard />;
};

const TOPNAV_SIZE_PX = 64;
const TOPNAV_INNER_X_PX = 16;
const TOPNAV_OUTER_Y_PX = 8;

const MASQUERADE_SIZE_PX = 40;

export function LargeNav() {
	const { leftSize } = useLeftHandLayout();
	const isMasquerade = useMasquerade();

	useNavTopSize(TOPNAV_SIZE_PX + (isMasquerade ? MASQUERADE_SIZE_PX : 0));
	useNavTopInnerX(TOPNAV_INNER_X_PX);
	useNavTopOuterY(TOPNAV_OUTER_Y_PX);

	return (
		<Stack
			component="nav"
			sx={{
				overflow: 'hidden',
				position: 'fixed',
				top: 0,
				left: leftSize,
				right: 0,
				padding: `${TOPNAV_OUTER_Y_PX}px`,
				paddingBottom: 0,
				bgcolor: (theme) => theme.vars.palette.uc.bg.weak,
				zIndex: (theme) => theme.zIndex.appBar,
			}}
		>
			<MasqueradeNote sx={{ paddingBottom: 200, marginBottom: -100 }} />
			<Stack
				direction="row"
				useFlexGap
				sx={{
					height: TOPNAV_SIZE_PX,
					padding: `${TOPNAV_INNER_X_PX}px`,
					alignItems: 'center',
					gap: 200,

					borderRadius: (theme) =>
						`${theme.borderRadius.roundedSm} ${theme.borderRadius.roundedSm} 0 0`,

					borderBottom: (theme) =>
						`1px solid ${theme.vars.palette.uc.border.weak}`,

					bgcolor: (theme) => theme.vars.palette.uc.bg.main,
					boxShadow: 1,
				}}
			>
				<LargeNavContent />
			</Stack>
		</Stack>
	);
}

export default LargeNav;
